// src/auth/RequireAdmin.jsx
import { useEffect, useRef } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";

import { useAuth } from "./AuthProvider";
import AppLoadingOverlay from "../components/ui/AppLoadingOverlay";

export default function RequireAdmin({ children }) {
  const {
    user,
    authLoading,
    role,
    blockedMessage,
    blockedReason,
    mustAcceptCurrentDisclaimer,
  } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const handledRef = useRef(false);

  const isAdmin = role === "admin";

  useEffect(() => {
    if (authLoading) return;

    // not logged in -> go login
    if (!user) {
      if (handledRef.current) return;
      handledRef.current = true;

      nav("/login", { replace: true, state: { from: loc } });
      return;
    }

    // blocked user/org -> logout + go login with message
    if (blockedReason) {
      if (handledRef.current) return;
      handledRef.current = true;

      (async () => {
        await signOut(auth).catch(() => {});
        nav("/login", {
          replace: true,
          state: {
            authError: blockedMessage || "Access blocked.",
            from: loc,
            toastId: Date.now(),
          },
        });
      })();
      return;
    }

    if (mustAcceptCurrentDisclaimer) {
      if (handledRef.current) return;
      handledRef.current = true;
      nav("/accept-disclaimer", { replace: true, state: { from: loc } });
    }
  }, [authLoading, user, blockedReason, blockedMessage, mustAcceptCurrentDisclaimer, nav, loc]);

  // While checking OR while blocked => show overlay only
  if (authLoading || blockedReason) {
    return (
      <AppLoadingOverlay
        title="Checking access…"
        subtitle="Verifying admin permissions"
        visible
      />
    );
  }

  if (!user) return null;

  if (mustAcceptCurrentDisclaimer) return null;

  // logged-in but not admin -> bounce to clients
  if (user && !isAdmin) {
    return <Navigate to="/clients" replace />;
  }

  return children;
}

// src/auth/RequireAdmin.jsx

// import { Navigate, useLocation } from "react-router-dom";
// import { useAuth } from "./AuthProvider";

// export default function RequireAdmin({ children }) {
//   const { user, authLoading, isAdmin } = useAuth();
//   const loc = useLocation();

//   if (authLoading) return null;

//   if (!user) {
//     return <Navigate to="/login" replace state={{ from: loc }} />;
//   }

//   if (!isAdmin) {
//     return <Navigate to="/clients" replace />;
//   }

//   return children;
// }

// src/auth/RequireAdmin.jsx

// import { Navigate, useLocation } from "react-router-dom";
// import { useAuth } from "./AuthProvider";

// export default function RequireAdmin({ children }) {
//   const { user, authLoading, isAdmin } = useAuth();
//   const loc = useLocation();

//   if (authLoading) return null;

//   if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;

//   if (!isAdmin) return <Navigate to="/clients" replace />;

//   return children;
// }
